import { APICore } from './api-core.service';

export let api = new APICore();
